<section class="icon-container">
	<div *ngIf="!fixedPricing">
		<img src="/assets/images/performance-pricing-icon.svg" alt="" srcset="" />
	</div>
	<div *ngIf="fixedPricing">
		<img src="/assets/images/fixed-pricing-icon.svg" alt="" srcset="" />
	</div>
</section>

<div class="text-container">
	<h2 class="model-title mt-3">Pricing Model</h2>
	<h3 *ngIf="!fixedPricing" class="model-type">Performance Based Pricing</h3>
	<h3 *ngIf="fixedPricing" class="model-type">Fixed Pricing</h3>
</div>
